"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _react = _interopRequireWildcard(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));
var _Chip = _interopRequireDefault(require("./Chip"));
var _CallLimiter = _interopRequireDefault(require("./CallLimiter"));
var _context2, _context3, _context4, _context5, _context9, _context11, _context13, _context16, _context18, _context19, _context21, _context22, _context23;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "chips-module__container___DE20C",
  "chips_container": "chips-module__chips_container___xpVhF",
  "input": "chips-module__input___E2Yuo",
  "list": "chips-module__list___tF0Sb",
  "suggestion": "chips-module__suggestion___z10lY",
  "highlighted": "chips-module__highlighted___fosc6"
};
const defaultTheme = {
  input: styles.input,
  container: styles.container,
  suggestion: styles.suggestion,
  suggestionHightlighted: styles.highlighted,
  suggestionsList: styles.list
};
class Chips extends _react.Component {
  static propTypes = {
    theme: T.object,
    value: T.array.isRequired,
    onChange: T.func,
    placeholder: T.string,
    suggestions: T.array,
    fetchSuggestions: T.func,
    fetchSuggestionsThrushold: T.number,
    fromSuggestionsOnly: T.bool,
    uniqueChips: T.bool,
    renderChip: T.func,
    suggestionsFilter: T.func,
    getChipValue: T.func,
    createChipKeys: T.array,
    getSuggestionValue: T.func,
    renderSuggestion: T.func,
    shouldRenderSuggestions: T.func,
    alwaysRenderSuggestions: T.bool,
    highlightFirstSuggestion: T.bool,
    focusInputOnSuggestionClick: T.bool,
    multiSection: T.bool,
    renderSectionTitle: T.func,
    getSectionSuggestions: T.func
  };
  static defaultProps = {
    placeholder: '',
    suggestions: [],
    fetchSuggestions: null,
    fetchSuggestionsThrushold: 10,
    createChipKeys: ['Tab'],
    fromSuggestionsOnly: false,
    uniqueChips: true,
    getSuggestionValue: s => s,
    theme: {},
    value: [],
    onChange: () => {},
    renderChip: value => /*#__PURE__*/_react.default.createElement(_Chip.default, null, value),
    renderLoading: () => /*#__PURE__*/_react.default.createElement("span", null, "Loading..."),
    renderSuggestion: suggestion => /*#__PURE__*/_react.default.createElement("span", null, suggestion),
    suggestionsFilter: (opt, val) => {
      var _context;
      return (0, _indexOf.default)(_context = opt.toLowerCase()).call(_context, val.toLowerCase()) !== -1;
    },
    getChipValue: item => item
  };
  state = {
    loading: false,
    value: '',
    chipSelected: false,
    suggestions: []
  };
  wrapperRef = /*#__PURE__*/_react.default.createRef();
  asyncSuggestLimiter = new _CallLimiter.default((0, _bind.default)(_context2 = this.callFetchSuggestions).call(_context2, this), 1000 / this.props.fetchSuggestionsThrushold);
  componentDidUpdate() {
    this.asyncSuggestLimiter.interval = 1000 / this.props.fetchSuggestionsThrushold;
  }
  onBlur = (0, _bind.default)(_context3 = this.onBlur).call(_context3, this);
  onBlur() {
    this.wrapperRef.current?.focus();
  }
  onFocus = (0, _bind.default)(_context4 = this.onFocus).call(_context4, this);
  onFocus() {
    this.wrapperRef.current?.blur();
  }
  handleKeyDown = (0, _bind.default)(_context5 = this.handleKeyDown).call(_context5, this);
  handleKeyDown(e) {
    var _context6, _context7;
    if (e.code === 'Enter' && this.lastEvent === e) {
      this.lastEvent = null;
      return;
    }
    if (!this.props.fromSuggestionsOnly && ((0, _includes.default)(_context6 = this.props.createChipKeys).call(_context6, e.code) || (0, _includes.default)(_context7 = this.props.createChipKeys).call(_context7, e.key))) {
      var _context8;
      e.preventDefault();
      if ((0, _trim.default)(_context8 = this.state.value).call(_context8)) this.addChip(this.state.value);
    }
    if (e.code === 'Backspace') {
      this.onBackspace();
    } else if (this.state.chipSelected) {
      this.setState({
        chipSelected: false
      });
    }
  }
  onBackspace = (0, _bind.default)(_context9 = this.onBackspace).call(_context9, this);
  onBackspace() {
    if (this.state.value === "" && this.props.value.length > 0) {
      if (this.state.chipSelected) {
        var _context10;
        const nextChips = (0, _slice.default)(_context10 = this.props.value).call(_context10, 0, -1);
        this.setState({
          chipSelected: false,
          chips: nextChips
        });
        this.props.onChange(nextChips);
      } else {
        this.setState({
          chipSelected: true
        });
      }
    }
  }
  addChip = (0, _bind.default)(_context11 = this.addChip).call(_context11, this);
  addChip(value) {
    var _context12;
    if (this.props.uniqueChips && (0, _indexOf.default)(_context12 = this.props.value).call(_context12, value) !== -1) {
      this.setState({
        value: ""
      });
      return;
    }
    let chips = [...this.props.value, value];
    this.props.onChange(chips);
    this.setState({
      value: ""
    });
  }
  removeChip = (0, _bind.default)(_context13 = this.removeChip).call(_context13, this);
  removeChip(idx) {
    return () => {
      var _context14, _context15;
      let left = (0, _slice.default)(_context14 = this.props.value).call(_context14, 0, idx);
      let right = (0, _slice.default)(_context15 = this.props.value).call(_context15, idx + 1);
      const nextChips = [...left, ...right];
      this.props.onChange(nextChips);
    };
  }
  renderChips = (0, _bind.default)(_context16 = this.renderChips).call(_context16, this);
  renderChips() {
    var _context17;
    return (0, _map.default)(_context17 = this.props.value).call(_context17, (chip, idx) => {
      return /*#__PURE__*/_react.default.cloneElement(this.props.renderChip(chip), {
        selected: this.state.chipSelected && idx === this.props.value.length - 1,
        onRemove: this.removeChip(idx),
        index: idx,
        key: `chip${idx}`
      });
    });
  }
  filterUniqueChips = (0, _bind.default)(_context18 = this.filterUniqueChips).call(_context18, this);
  filterUniqueChips(suggestions) {
    let {
      value,
      getChipValue,
      getSuggestionValue
    } = this.props;
    return (0, _filter.default)(suggestions).call(suggestions, suggestion => !(0, _some.default)(value).call(value, chip => getChipValue(chip) == getSuggestionValue(suggestion)));
  }

  // callFetchSuggestions = this.callFetchSuggestions.bind(this);
  callFetchSuggestions(fetchSuggestions, value, canceled) {
    let {
      uniqueChips
    } = this.props;
    let callback = suggestions => {
      if (!canceled.isCancaled()) {
        this.setState({
          loading: false,
          suggestions: uniqueChips ? this.filterUniqueChips(suggestions) : suggestions
        });
      }
    };
    let suggestionResult = fetchSuggestions.call(this, value, callback);
    if (suggestionResult && 'then' in suggestionResult) {
      // To Support Promises
      suggestionResult.then(callback);
    }
  }
  onSuggestionsFetchRequested = (0, _bind.default)(_context19 = this.onSuggestionsFetchRequested).call(_context19, this);
  onSuggestionsFetchRequested({
    value
  }) {
    let {
      uniqueChips,
      suggestions,
      fetchSuggestions,
      suggestionsFilter
    } = this.props;
    if (fetchSuggestions) {
      this.setState({
        loading: true
      });
      this.asyncSuggestLimiter.invoke(fetchSuggestions, value);
    } else {
      var _context20;
      this.setState({
        suggestions: (0, _filter.default)(_context20 = uniqueChips ? this.filterUniqueChips(suggestions) : suggestions).call(_context20, opts => suggestionsFilter(opts, value))
      });
    }
  }
  onSuggestionsClearRequested = (0, _bind.default)(_context21 = this.onSuggestionsClearRequested).call(_context21, this);
  onSuggestionsClearRequested() {
    this.setState({
      suggestions: []
    });
  }
  onSuggestionSelected = (0, _bind.default)(_context22 = this.onSuggestionSelected).call(_context22, this);
  onSuggestionSelected(e, {
    suggestion
  }) {
    this.lastEvent = e;
    this.addChip(suggestion);
    this.setState({
      value: ''
    });
  }
  onChange = (0, _bind.default)(_context23 = this.onChange).call(_context23, this);
  onChange(e, {
    newValue
  }) {
    var _context24;
    if (!this.props.fromSuggestionsOnly && (0, _indexOf.default)(newValue).call(newValue, ',') !== -1 && (0, _includes.default)(_context24 = this.props.createChipKeys).call(_context24, 'Tab')) {
      var _context25, _context26;
      let chips = (0, _filter.default)(_context25 = (0, _map.default)(_context26 = newValue.split(",")).call(_context26, val => (0, _trim.default)(val).call(val))).call(_context25, val => val !== "");
      (0, _forEach.default)(chips).call(chips, chip => {
        this.addChip(chip);
      });
    } else {
      this.setState({
        value: newValue
      });
    }
  }
  render() {
    const {
      placeholder,
      renderLoading,
      theme,
      ...otherProps
    } = this.props;
    const {
      loading,
      value,
      suggestions
    } = this.state;
    const inputProps = {
      placeholder,
      value,
      className: styles.input,
      onChange: this.onChange,
      onKeyDown: this.handleKeyDown,
      onBlur: this.onBlur,
      onFocus: this.onFocus
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.chips_container,
      ref: this.wrapperRef
    }, this.renderChips(), /*#__PURE__*/_react.default.createElement(_reactAutosuggest.default, (0, _extends2.default)({}, otherProps, {
      theme: {
        ...defaultTheme,
        ...theme
      },
      suggestions: suggestions,
      onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
      onSuggestionsClearRequested: this.onSuggestionsClearRequested,
      getSuggestionValue: () => this.state.value,
      inputProps: inputProps,
      onSuggestionSelected: this.onSuggestionSelected
    })), loading ? renderLoading() : null);
  }
}
exports.default = Chips;